<div id="app-consumer-verification-code" class="dialog-content-wrapper"
    [ngStyle]="{'--form-input-text-color': settingsData.form_font_secondary_color || null, 'background-color':this.settingsData.form_bg_color?this.settingsData.form_bg_color:'', 'border-radius': this.settingsData.form_bg_color ? '20px':'','padding':this.settingsData.form_bg_color?'10px':'','font-family': settingsData.font_family ? settingsData.font_family : ''}">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center">
            <span
                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-size': settingsData.form_fs_main_title ? settingsData.form_fs_main_title: '' , 'font-family': settingsData.font_family ? settingsData.font_family : ''  }">
                Verification</span>
        </mat-toolbar-row>

    </mat-toolbar>
    <!-- <mat-divider></mat-divider> -->
    <div mat-dialog-content>
        <form [formGroup]="verificationForm">
            <div fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="center center" class="p-lr-15">

                <div fxFlex="100%">
                    <mat-form-field class="w-100">
                        <mat-label
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">
                            <span
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">Verification
                                Code</span></mat-label>
                        <input matInput name="codeOTP"
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }"
                            formControlName="codeOTP" required>
                        <mat-error *ngIf="verificationForm.get('codeOTP').hasError('required')">
                            Please enter OTP
                        </mat-error>
                    </mat-form-field>
                </div>

                <div fxFlex="100%" fxLayoutAlign="center center" class="mtb-5">
                    <!-- <button mat-flat-button class="square-btn" (click)="verificationOTP()">
                        Verify
                    </button> -->
                    <button mat-flat-button class="flat-primary-button" [ngClass]="{'tertiary-bg-btn1':!router.url.includes('/channel/')}" [ngStyle]="{'background-color': settingsData.form_bg_secondary_color ? settingsData.form_bg_secondary_color : '' ,'color': settingsData.form_font_primary_color ? settingsData.form_font_primary_color : '' ,
                    'font-family': settingsData.font_family ? settingsData.font_family : ''  }"
                        (click)="OL_verificationOTP()">
                        Verify
                    </button>
                </div>
                <div fxFlex="100%" fxLayoutAlign="start center" class="mtb-5" class="back-to-login pointer">
                    <div fxFlex="100%"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }"
                        fxLayoutAlign="start center" (click)="OpenSign()">
                        <span>Go To Sign In</span>
                    </div>
                    <!-- <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="end center" (click)="resendSignUp()">
                        <span>Resend Code</span>
                    </div> -->
                    <div fxFlex="100%" fxLayoutAlign="end center" (click)="OL_resendVerifyCode()">
                        <span
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">Resend
                            Code</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
